<template>
  <div class="form-dlg">
    <el-dialog
      :title="isUpdate ? '编辑' : '新增'"
      :visible.sync="showDlg"
      width="60%"
      @open="openForm"
      @closed="closedForm"
    >
      <div class="dialog-content">
        <el-form ref="form" :model="formData" :rules="rules" label-width="120px">
          <el-form-item prop="name" label="姓名">
            <el-input v-model="formData.name" clearable></el-input>
          </el-form-item>
          <el-form-item prop="sex" label="性别">
            <el-radio-group v-model="formData.sex">
              <el-radio label="0">男</el-radio>
              <el-radio label="1">女</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item prop="birthday" label="生日">
            <el-date-picker
              v-model="formData.birthday"
              type="date"
              placeholder="选择日期"
              clearable
              value-format="timestamp"
              style="width: 100%;"
            ></el-date-picker>
          </el-form-item>
          <el-form-item prop="money" label="金额">
            <el-input v-model.number="formData.money" type="number" clearable></el-input>
          </el-form-item>
          <el-form-item prop="address" label="地址">
            <el-input v-model="formData.address" type="textarea"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="$emit('change', false)">取 消</el-button>
        <el-button type="primary" :loading="loading" @click="handleSubForm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mockUpdTableData } from '@/mock/demo.js'

export default {
  name: 'form-dlg',
  model: {
    prop: 'value',
    event: 'change',
  },
  components: {},
  props: {
    value: Boolean,
    data: Object,
  },
  data() {
    return {
      loading: false,
      formData: {},
      rules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        sex: [{ required: true, message: '请选择性别', trigger: 'change' }],
        birthday: [{ required: true, message: '请选择生日', trigger: 'change' }],
      },
    }
  },
  computed: {
    showDlg: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('change', val)
      },
    },

    // 编辑模式
    isUpdate() {
      return this.data && (this.data.id || this.data.id === 0)
    },
  },
  watch: {},
  created() {},
  mounted() {},
  beforeDestroy() {},
  methods: {
    // 确定按钮
    handleSubForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.updFormData()
        }
      })
    },

    // 重置表单
    resetForm() {
      this.$refs.form.resetFields()
    },

    // 弹窗打开
    openForm() {
      if (this.isUpdate) {
        this.$nextTick(() => {
          this.formData = {
            ...this.formData,
            ...this.data,
          }
        })
      }
    },

    // 弹窗关闭动画结束
    closedForm() {
      this.resetForm()
    },

    // 新增/更新数据
    updFormData() {
      this.loading = true
      mockUpdTableData().then(res => {
        this.$message.success('操作成功')
        this.loading = false
        this.$emit('change', false)
        this.$emit('submit-form', res)
      })
    },
  },
}
</script>

<style lang="less" scoped>
.form-dlg {
  .dialog-content {
    overflow: auto;
    max-height: 50vh;
  }
}
</style>
